<button
    name="annotationTool"
    type="button"
    class="btn btn-default nlr-icon-btn"
    id="annotationToolBtn"
    class="btn btn-default nlr-icon-btn"
    right-click="annotationTools"
    [ngClass]="{active : isWidgetActive()}"
    [title]="getTooltip()"
    [disabled]="isWidgetDisabled()"
    (click)="onClick()">
    <i class="nlrp-icon nlrp-icon-annotation"></i>
</button>
@if (isWidgetActive()) {
    <div
        id="annotationTools"
        class="widget container-fluid well"
        cdkDrag
        [cdkDragConstrainPosition]="computeDragPosition"
        #widget>
        <form
            id="annotationToolsForm"
            #annotationToolsForm="ngForm"
            novalidate
            autocomplete="off">
            <div
                class="col-xs-12 widget-header"
                cdkDragHandle>
                <span>{{widgetConfig.header}}</span>
                <div class="pull-right btn-group btn-group-xs">
                    <nlrp-help-link
                        [url]="getHelpUrl()"
                        [pageTitle]="getHelpPageTitle()"></nlrp-help-link>
                    <i
                        title="{{open ? widgetConfig.collapseTooltip : widgetConfig.expandTooltip}}"
                        class="nlrp-icon nlrp-18"
                        [ngClass]="open ? 'nlrp-icon-up-chevron' : 'nlrp-icon-down-chevron'"
                        (click)="showOrHide()">
                    </i>
                    <i
                        class="nlrp-icon nlrp-icon-close-cancel nlrp-18"
                        id="closeAnnotationBtn"
                        title="{{widgetConfig.closeTooltip}}"
                        (click)="closeWidget();"></i>
                </div>
            </div>
            <div
                class="widget-content"
                [hidden]="!open">
                <div class="mgt10">
                    <div class="col-xs-12">
                        <!-- Nav tabs -->
                        @for (toolRow of toolRows; track toolRow) {
                            <ul
                                class="nav nav-tabs"
                                role="tablist">
                                @for (tool of toolRow.tools.sort(compareOrder); track tool) {
                                    <li role="presentation">
                                        <a
                                            aria-controls="{{tool.type}}AnnotationToolTab"
                                            role="tab"
                                            data-toggle="tab"
                                            class="icon-tab">
                                            <button
                                                id="{{tool.type}}AnnotationToolTabBtn"
                                                type="button"
                                                class="btn btn-default nlr-icon-btn"
                                                title="{{tool.tooltip}}"
                                                [ngClass]="selectedAnnotationTool.id === tool.id ? 'active' : ''"
                                                (click)="changeSelectedAnnotationTool(tool)"
                                                [disabled]="tool.permissions | disabledByPermissions">
                                                <i class="nlrp-icon {{tool.icon}}"></i>
                                            </button>
                                        </a>
                                    </li>
                                }
                            </ul>
                        }
                        <!-- Tab panes -->
                        <div class="tab-content">
                            <li
                                role="presentation"
                                class="divider"></li>
                            @for (toolRow of toolRows; track toolRow) {
                                <div>
                                    @for (tool of toolRow.tools.sort(compareOrder); track tool) {
                                        <div>
                                            <nlr-annotation-tool
                                                id="{{tool.type}}AnnotationToolTab"
                                                [parentForm]="annotationToolsForm"
                                                [tool]="tool"
                                                [active]="tool.type === selectedAnnotationTool.type">
                                            </nlr-annotation-tool>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            @if (showAttribute()) {
                <div class="col-xs-12 inline-bottom-buttons">
                    <button
                        class="btn btn-default nlr-btn-sm create"
                        id="annotationToolsCreateBtn"
                        (click)="create()"
                        [ngClass]="{active : isCreateActive()}"
                        [disabled]="isCreateDisabled() || isDisabledByPermissions()">
                        {{selectedAnnotationTool.type === 'edit' ? 'Apply' : isCreateActive()
            ? selectedAnnotationTool.finishButtonLabel
            : selectedAnnotationTool.createButtonLabel}}</button
                    >
                    @if (selectedAnnotationTool.clearButtonLabel) {
                        <button
                            class="btn btn-default nlr-btn-sm clear"
                            (click)="clear()"
                            [disabled]="toolsDisabled() || ( selectedAnnotationTool.permissions | disabledByPermissions)">
                            {{selectedAnnotationTool.clearButtonLabel}}
                        </button>
                    }
                    <button
                        class="btn btn-default nlr-btn-sm cancel"
                        id="cancelAnnotationBtn"
                        (click)="closeWidget()">
                        {{selectedAnnotationTool.closeButtonLabel}}
                    </button>
                </div>
            }
        </form>
    </div>
}
